import { Link, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import ReactGA from 'react-ga4';
import './home.css'
import { Helmet } from 'react-helmet';

function Home() {
    const location = useLocation()

    const steps = [
        { title: 'CLONE REPO', desc: 'npm install' },
        { title: 'CREATE SANITY ACCOUNT', desc: 'Create new project' },
        { title: 'SETUP FILES', desc: 'Modify as per your need' },
        { title: 'NPM START', desc: 'Start your project' }
    ]

    useEffect(() => {
        const { hash } = location
        if (hash) {
            const element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location])

    const handleCheckoutBtn = () => {
        ReactGA.event({
            action: "Checkout navigation",
            category: "User interaction",
            label: "Checkout navigation"
        })
    }

    return (
        <div className="bg-[#161623] ">
            <Helmet>
                <title>BlogCode - ReactJS boilerplate for blogs</title>
                <meta name="description" content='Setup Blog in minutes' />
                <meta name="keywords" content="react, blog, SEO, tips, blogging, reactjs" />
                <meta name="author" content="Nimish Bandha" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <link rel="canonical" href="https://getblogcode.netlify.app" />
            </Helmet>
            <main className='h-full min-h-screen'>
                <section className='text-center flex flex-col items-center pt-40 gap-8'>
                    <div className='ring-1 text-[#2196F3] ring-[#2196F3]/50 rounded-full text-center w-fit px-4 py-1 text-sm hover:ring-[#2196F3]' >
                        Powered By Sanity
                    </div>
                    <h1 className='text-4xl sm:text-5xl tracking-wider text-white'>Get your Blog up & running in Minutes </h1>
                    <h2 className='text-gray-300 text-xl max-w-2xl md:max-w-full'>
                        With our customizable React + Sanity boilerplate, launch your blog quickly and effortlessly.
                    </h2>
                    <Link to="/checkout" className='bg-[#2196f3] text-gray-100 py-2 px-6 tracking-wider rounded relative group overflow-hidden' onClick={() => handleCheckoutBtn()}>
                        <span className='inline-block'>Get BlogCode</span>
                        <span className='inline-block ml-2 transition-transform group-hover:translate-x-2'>→</span>
                    </Link>
                    <span className='text-gray-400 text-sm mt-[-10px]'>LIMITED OFFER - 50% DISCOUNT FOR FIRST 10 USERS</span>
                </section>
                <section className='flex items-center justify-center p-4 container mx-auto gap-3 sm:gap-10 pt-6'>
                    <img src='assets/reactjs.svg' alt="react logo" className='w-1/3 lg:w-72' />
                    <span className='text-gray-100 text-4xl '>+</span>
                    <img src='assets/sanity.svg' alt="sanity logo" className='w-1/2 lg:w-96' />
                </section>


                <section className='flex justify-center py-14 '>
                    <div className='overflow-hidden flex gap-5 lg:max-w-[70%] 2xl:max-w-[1350px] slider'>

                        {[...steps, ...steps].map(({ title, desc }) => (
                            <div className='px-6 py-6 bg-gradient45 min-w-[300px] w-fit rounded-md slide-track'>
                                <h3 className='uppercase text-white font-semibold text-2xl'>
                                    {title}
                                </h3>
                                <span className='text-gray-400 text-xl'>{desc}</span>
                            </div>
                        ))}

                    </div>
                </section>

                <section className='bg-[#2A2A42] flex flex-col items-center py-6' id="features">
                    <h2 className='text-3xl text-gray-300 text-center' >
                        Why use BlogCode for Blogging?</h2>

                    <div className='py-12 flex md:max-w-[95%] lg:max-w-[70%] xl:max-w-[800px] flex-grow flex-wrap justify-center gap-8'>

                        <div className='flex flex-col items-center justify-center bg-gradientFeat rounded-lg px-14 py-4 text-gray-400 gap-8 max-w-[300px] text-center'>
                            <img src='assets/gear.svg' alt="setup" className='w-fit' />
                            <span>Easy setup of Sanity CMS</span>
                        </div>
                        <div className='flex flex-col items-center justify-center bg-gradientFeat rounded-lg px-14 py-4 text-gray-400 gap-8 max-w-[300px] text-center'>
                            <img src='assets/pc.svg' alt="setup" className='w-fit' />
                            <span className=''>Ready-to-use ReactJS boilerplate code</span>
                        </div>
                        <div className='flex flex-col items-center justify-center bg-gradientFeat rounded-lg px-14 py-4 text-gray-400 gap-8 max-w-[300px] text-center'>
                            <img src='assets/tools.svg' alt="setup" className='w-fit' />
                            <span>Customizable Code for your blog</span>
                        </div>
                        <div className='flex flex-col items-center justify-center bg-gradientFeat rounded-lg px-14 py-4 text-gray-400 gap-8 max-w-[300px] text-center'>
                            <img src='assets/pencil.svg' alt="setup" className='w-fit' />
                            <span>Effortless content editing using Sanity</span>
                        </div>

                    </div>
                    <Link to="/checkout" className='bg-[#2196f3] text-gray-100 py-2 px-6 tracking-wider rounded relative group overflow-hidden' onClick={() => handleCheckoutBtn()}>
                        <span className='inline-block'>Get BlogCode</span>
                        <span className='inline-block ml-2 transition-transform group-hover:translate-x-2'>→</span>
                    </Link>
                </section>

                <section className='flex flex-col items-center justify-center py-16 gap-12'>
                    <h2 className='text-3xl text-gray-300 text-center'>
                        If you DONT use BlogCode for Blogging?</h2>

                    <div className='flex flex-col text-gray-400 text-xl md:text-2xl bg-[#2A2A42] py-4 px-3 md:px-8 rounded-md leading-relaxed'>
                        <span>❌ Manual Configuration of CMS</span>
                        <span>❌ No pre-built ReactJS code</span>
                        <span>❌ Limited customization options</span>
                        <span>❌ Complex content editing process</span>
                    </div>
                </section>
                <section className='bg-[#2A2A42] flex justify-center py-12'>
                    <div className='flex items-center md:items-start gap-5 max-w-screen-sm md:flex-row flex-col'>
                        <img src='assets/nimish.png' alt="nimish" className='w-28 object-contain' />
                        <div className='px-4'>
                            <h2 className='text-gray-300 text-2xl'>Hey, It's Nimish</h2>
                            <p className='text-gray-400'>
                                I'm a self-taught Fullstack Web Developer. I wrote my first line of code at the age of 13.
                                <br /><br />
                                I noticed a need of Blogging tool which gave full control over your blog & help you setup a blog in minutes not hours which is fully customizable. So I built BlogCode.
                                <br />< br />
                                You can find me on <a href="https://twitter.com/BandhaNimish" target="_blank" rel="noreferrer" className='text-gray-100 font-medium'>X (Twitter)</a> and <a href="https://instagram.com/programmer_nimish" target="_blank" rel="noreferrer" className='text-gray-100 font-medium'>Instagram</a>
                            </p>
                        </div>
                    </div>
                </section >

                <section className='flex flex-col justify-center items-center gap-8 py-12 container mx-auto px-auto lg:px-[15rem]'>
                    <h2 className='text-3xl text-gray-300 text-center'>Demo in 3 Minutes</h2>
                    <div className='aspect-video w-full'>
                        <iframe className='h-full w-full' src="https://www.youtube.com/embed/5hmjGRZmefc?si=bQUc1x-8Z-VzSQCu" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen="allowfullscreen"></iframe>
                    </div>

                </section>

                <section className='flex flex-col items-center py-12 gap-8' id="pricing">
                    <h2 className='text-3xl text-gray-300'>PRICING</h2>
                    <div className='rounded p-8 text-gray-300 bg-[#2A2A42] flex flex-col gap-10'>
                        <h3 className='text-xl font-semibold'>One-Time Investment of</h3>
                        <div className='tracking-tighter '>
                            <span className='line-through text-gray-400 text-3xl font-bold mr-3'>$29</span>
                            <span className='text-6xl font-bold'>$15</span>
                            <div className='text-base text-gray-400'>50% DISCOUNT FOR FIRST 10 USERS</div>
                        </div>
                        <ul className='list-none text-left text-xl tracking-wide leading-10'>
                            <li><span>✅</span>Easy setup of Sanity CMS</li>
                            <li><span>✅</span>Ready-to-use ReactJS boilerplate code</li>
                            <li><span>✅</span>Customizable Code for your blog</li>
                            <li><span>✅</span>Effortlessly edit content using Sanity</li>
                        </ul>
                        <Link to="/checkout" className='bg-[#2196f3] text-gray-100 py-2 px-6  tracking-wider rounded relative group overflow-hidden self-center mt-2 w-full text-center' onClick={() => handleCheckoutBtn()}>
                            <span className='inline-block'>Get BlogCode</span>
                            <span className='inline-block ml-2 transition-transform group-hover:translate-x-2'>→</span>
                        </Link>
                    </div>
                </section>
            </main >

        </div >
    )
}

export default Home